var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk15S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.166.781c4.517 0 8.175 3.68 8.175 8.226 0 4.545-3.664 8.225-8.175 8.225-4.51 0-8.174-3.68-8.174-8.225S23.65.78 28.166.78Z",
    fill: "#E8021C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.347 11.56c-.336-1.058-.325-2.224.13-3.584.717-2.144 2.845-3.48 4.08-3.646 1.234-.17 1.632-.085 2.553-.102.922-.017 1.65 0 2.253-.029.603-.028 2.543.216 3.777 2.213 1.234 2.002.7 4.938-.319 6.41-1.297 1.878-2.48 2.339-4.522 2.544-3.316.33-6.775-.069-7.952-3.806Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.638 2.852c.534.33.495 1.2-.086 1.94-.58.739-1.484 1.074-2.019.744-.535-.33-.495-1.2.085-1.94.58-.739 1.485-1.074 2.02-.744Z",
    fill: "#FFBABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.244 12.79V6.85a.716.716 0 0 0-.711-.716h-1.434c-.893 0-.893 1.405 0 1.405h.62v5.25c0 .956 1.525.956 1.525 0Zm2.994-5.251h1.837c.893 0 .893-1.405 0-1.405H30.64a.672.672 0 0 0-.665.603c-.017.125-.239 1.928-.313 2.531-.034.284-.011.671.29.802.25.114.7-.04.876-.148.177-.108.592-.199.933-.12.887.206.785 2.106-.301 2.322-.598.12-1.274-.427-1.297-.45-.649-.534-1.502.393-.967 1.007.432.506 1.211.762 1.848.814 1.292.108 2.299-.717 2.623-1.616.324-.899.142-2.184-.381-2.719a2.09 2.09 0 0 0-2.196-.478l.148-1.143Z",
    fill: "#330303"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.129 6.327h2.844l-.376 1.024H3.811l-.728 1.985h1.41l-.375 1.024h-1.41l-.723.461.552.006-.933 2.542H0l.7-.426 2.429-6.616Zm9.561 5.763c-.672 1.87-3.658 1.87-2.987 0l.33-.922h1.047l-.336.938c-.199.563.7.563.899 0 .176-.5.307-.836.17-1.285-.153-.507-.568-.848-.785-1.349-.216-.506.12-1.274.342-1.888.66-1.854 3.595-1.877 2.924 0l-.33.921h-1.48l.598-.455.17-.483c.2-.563-.699-.563-.898 0-.182.506-.37.882-.182 1.314.176.41.466.717.768 1.268.284.518-.017 1.292-.25 1.94Zm3.234-5.763h3.538l-.363.99h-1.28l-.751.518.586-.006-1.98 5.54H14.06l.705-.426 1.997-5.626h-1.2l.363-.99Zm-7.927 0h1.558L7.911 13.37h-1.04l.358-1.592h-.916l-.78 1.592H4.442l3.556-7.042Zm-.484 4.426.649-2.725-1.104 2.264-.75.46h1.205Z",
    fill: "#50039D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.999 8.801c-.023-.552-.9-.785-1.098-.864-.205-.08-.325-.21-.24-.393.12-.273.581-.108.746.017.33.24.723-.216.438-.506-.199-.21-.734-.313-1.012-.273-.49.068-.87.392-.894.887-.034.723.7.763 1.144.973.13.063.273.188.21.347-.074.188-.335.154-.472.136a.956.956 0 0 1-.45-.199c-.29-.216-.67.143-.494.444.16.262.66.438.95.444.591.011 1.194-.393 1.172-1.013ZM37.495 6.31a.304.304 0 0 1 .102.415l-.353.591a.304.304 0 0 1-.415.103.304.304 0 0 1-.102-.415l.352-.592a.305.305 0 0 1 .416-.102Z",
    fill: "#330303"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.477 16.97 14.818-.352-2.253-1.041 7.702-1.223-12.315.648 3.151.876L.477 16.97Z",
    fill: "#F3D86F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk15S);
export default __webpack_public_path__ + "static/media/uk_15s.9bafcc1634b98da7af833861bf01138c.svg";
export { ForwardRef as ReactComponent };